<template>
  <div class="col-lg-12 rowsThere">
    <div class="d-flex justify-content-between align-items-center border-top1">
      <div>
        <h3 class="hover-h3" v-on:click="$emit('edit-order', order.id)">{{order.firstname}} {{order.lastname}} - {{createdFmt}}</h3>
        <p class="no-bottom">Order: <b>#{{order.id}}</b></p>
        <p class="no-bottom">Product Count: <b>{{order.products.length}}</b></p>
      </div>
      <div>
        <button v-on:click="$emit('edit-order', order.id)" class="btn btn-info">View</button>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    props: {
      order: {
        type: Object,
        default: function () {
          return {
            id: "",
            created: "",
            status: "",
            firstname: "",
            lastname: "",
            email: "",
            phone: "",
            shipping_type: "",
            shipping_address: "",
            shipping_cost: 0,
            products: [],
          };
        },
      },
    },
    computed: {
      createdFmt() {
        return moment(this.order.created).format("MMMM DD, YYYY");
      }
    }
  };
</script>